import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartSummaryList } from "../../Redux/Slices/AddToCartSlice";

const CartSummary = ({
  title,
  codeSaved,
  subTotal,
  setSubTotal,
  totalAmount,
  setTotalAmount,
}) => {
  const dispatch = useDispatch();
  const { cartSummeryData ,cartList} = useSelector((e) => e.AddToCartSlice);
  const CalculationSubTotal = async() => {
    const subTotal = await cartList?.map((e) => {
      return (e?.mrp * e?.addCount)
    });
    const discountTotal = await cartList?.map((e) => {
      return ( (e?.mrp - e.sellingPrice) * e?.addCount)
    });
    // const flatSubTotal = await subTotal.flat();
    // const flatDiscountTotal = await discountTotal.flat();
    const finalSubTotalCount = subTotal.reduce((acu, cur) => acu + cur, 0);
    const finalDiscountTotalCount = discountTotal.reduce(
      (acu, cur) => acu + cur,
      0
      );
      console.log(finalSubTotalCount,finalDiscountTotalCount,"discountTotal")
    //   console.log(finalDiscountTotalCount,"flatDiscountTotal",flatDiscountTotal)
    // console.log(finalSubTotalCount, "subtotal", finalDiscountTotalCount);
    dispatch(
      cartSummaryList({
        subTotal: finalSubTotalCount,
        discountTotal: finalDiscountTotalCount,
        shippingCharge: 0,
        total: finalSubTotalCount - finalDiscountTotalCount,
      })
    );
  };
  useEffect(() => {
    if (cartList?.length !== "0") {
      CalculationSubTotal();
    }
  }, [cartList]);
  return (
    <div className="table-content">
      <div className="title-wraper">
        <div className="table-title">{title}</div>
      </div>
      <div className="content-wrapper">
        <ul className="payment-detil-list">
          <li>
            <p>Sub Total</p>
            {/* {console.log("SubTotal",SubTotal)} */}
            {/* {OrderProducts && title === "Payment" ? (
              <p>
                <b>₹ {}</b>
              </p>
            ) : ( */}
            <p>
              <b>
                ₹{new Intl.NumberFormat().format(cartSummeryData?.subTotal)}
              </b>{" "}
            </p>
            {/* )} */}
          </li>
          <li>
            <p>Discount</p>

            <p>
              {/* <p>{promoCode ? <b>₹ 6,399</b> : <b>₹ 0 </b>}</p> */}
              <b>
                {" "}
                -₹
                {new Intl.NumberFormat().format(cartSummeryData?.discountTotal)}
              </b>
            </p>
          </li>
          <li>
            <p>Shipping Charge</p>
            <p>
              <b>
                ₹{" "}
                {new Intl.NumberFormat().format(
                  cartSummeryData?.shippingCharge
                )}
              </b>
            </p>
          </li>
          <li>
            <p>
              <b>Total Amount</b>
            </p>
            {/* {OrderProducts && title === "Payment" ? (
              <p>
                <b>₹ {formatNumber(OrderProducts?.sellingPrice)}</b>
              </p>
            ) : (
              <p>
                {TotalAmount > 0 ? (
                  <b>
                    ₹{" "}
                    {promoCode
                      ? formatNumber(TotalAmount - 6399)
                      : formatNumber(TotalAmount)}
                  </b>
                ) : ( */}
            <p>
              <b>₹ {new Intl.NumberFormat().format(cartSummeryData?.total)} </b>
              {/* )} */}
            </p>
            {/* )} */}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CartSummary;
